import React from 'react';
import { useNavigate } from 'react-router-dom';

export const Footer = () => {
  const navigate = useNavigate();
  
  return (
    <footer className="bg-gray-800 text-white py-6 sm:py-8 mt-auto">
      <div className="container mx-auto px-2 sm:px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          <div className="flex flex-col">
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Navigation</h3>
            <ul className="space-y-1 sm:space-y-2 text-gray-300 text-sm sm:text-base flex-1">
              <li>
                <button 
                  onClick={() => navigate('/')} 
                  className="hover:text-white transition-colors text-left block w-full"
                >
                  Home
                </button>
              </li>
              <li>
                <button 
                  onClick={() => navigate('/create-petition')} 
                  className="hover:text-white transition-colors text-left block w-full"
                >
                  Create Petition
                </button>
              </li>
              <li>
                <button 
                  onClick={() => navigate('/petitions')} 
                  className="hover:text-white transition-colors text-left block w-full"
                >
                  View All Petitions
                </button>
              </li>
            </ul>
          </div>
          
          <div className="flex flex-col">
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Legal</h3>
            <ul className="space-y-1 sm:space-y-2 text-gray-300 text-sm sm:text-base flex-1">
              <li>
                <button 
                  onClick={() => navigate('/privacypolicy')} 
                  className="hover:text-white transition-colors text-left block w-full"
                >
                  Privacy Policy
                </button>
              </li>
              <li>
                <button 
                  onClick={() => navigate('/terms-and-conditions')} 
                  className="hover:text-white transition-colors text-left block w-full"
                >
                  Terms and Conditions
                </button>
              </li>
            </ul>
          </div>

          <div className="flex flex-col sm:col-span-2 lg:col-span-1">
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">How it works</h3>
            <ul className="space-y-1 sm:space-y-2 text-gray-300 text-sm sm:text-base flex-1">
              <li>• Create or sign petitions</li>
              <li>• Get 10 signatures for a response</li>
              <li>• Get 20 signatures for a potential debate in Parliament</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-6 sm:mt-8 pt-6 sm:pt-8 text-center text-gray-400">
          <p className="text-xs sm:text-sm">&copy; 2025 Reiss. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

// Manage Parliamentary Terms Page (System Administrator Only)
